import moment from 'moment-jalaali';

import { Notification as API } from '@src/api/types';
import { Notification as Data } from '@src/types';

import generateUser from './user';

const Factory = (api: API): Data => {
  const user = JSON.parse(api.extra.person);

  return {
    id: api.date.toString(),
    type: api.type,
    user: user ? generateUser(user) : undefined,
    cover: api.extra.imageUrl ? { uri: api.extra.imageUrl } : undefined,
    link: api.extra.link ? api.extra.link : undefined,
    entityType: api.extra.entityType,
    entityId: api.extra.entityId,
    parentEntityType: api.extra.parentEntityType,
    parentEntityId: api.extra.parentEntityId,
    count: api.count,
    content: api.extra?.text ?? api.title?.[0].text ?? '',
    seen: api.seen,
    date: moment.unix(api.date / 1000),
  };
};

export default Factory;
